import { RETAIL_ROLE_POS_ADMIN_ALIAS } from '../../constants/retailRoles';
import SellerSalesPage from './SellerSalesPage';
import PosAdminSalesPage from './PosAdminSalesPage';

/**
 * Maps POS role alias → sales list page component.
 * Default: seller view (branch-scoped list; backend enforces scope).
 */
const SALES_PAGE_BY_ROLE_ALIAS = {
  [RETAIL_ROLE_POS_ADMIN_ALIAS]: PosAdminSalesPage,
};

export function resolveSalesPageComponent(posRoleAlias) {
  return SALES_PAGE_BY_ROLE_ALIAS[posRoleAlias] ?? SellerSalesPage;
}
